import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import I18n from '@module/i18n';
import Illustration from '@component/illustration';
import Router from '@module/router';
import Actions from '@app/action';
import Analytics from '@module/analytics';

export class Aborted extends React.Component {
  retryTransfer = () => {
    this.props.resetTransferState();
  };

  gotoTransfers() {
    Router.navigateTo('/transfers');
  }

  gotoHelp() {
    Router.navigateTo('/help');
  }

  gotoPayment() {
    Analytics.loadTrackingPixel('WT_Plus_go_to_Check_out_Conv');

    Router.navigateTo('/payment/retry');
  }

  doSignout = (e) => {
    e.preventDefault();
    this.props.signout();
  };

  componentDidMount() {
    if (
      this.props.transfer.lastError === 'AccountExpired' ||
      this.props.transfer.lastError === 'AccountInactive'
    ) {
      if (!this.node) {
        return;
      }

      const signoutLink = this.node.querySelector('p a');
      if (!signoutLink) {
        return;
      }

      signoutLink['onclick'] = this.doSignout;
    }
  }

  // Let's render our aborted screen (spinner?) and pause buttons.
  render() {
    let button = I18n.t('transfer.buttons.retry');
    let action = this.retryTransfer;
    let title = I18n.t('transfer.failed.title');
    let text = I18n.t('transfer.failed.text');

    switch (this.props.transfer.lastError) {
      case 'LimitReached':
        button = I18n.t('transfer.buttons.cleanup');
        action = this.gotoTransfers;
        title = I18n.t('transfer.storage_full.title');
        if (this.props.storageLimit) {
          text = I18n.t('transfer.storage_full.text_with_limit', {
            storageLimit: I18n.size(this.props.storageLimit, {
              precision: 0,
            }),
          });
        } else {
          text = I18n.t('transfer.storage_full.text');
        }
        break;

      case 'UserBlocked':
        text = I18n.t('transfer.bubble.errors.blocked');
        button = I18n.t('transfer.buttons.help');
        action = this.gotoHelp;
        break;

      case 'AccountExpired':
        title = I18n.t('transfer.account_expired.title');
        text = I18n.t('transfer.account_expired.text');
        button = I18n.t('transfer.buttons.payment');
        action = this.gotoPayment;
        break;

      case 'AccountInactive':
        title = I18n.t('transfer.account_inactive.title');
        text = I18n.t('transfer.account_inactive.text');
        button = I18n.t('transfer.buttons.complete_order');
        action = this.gotoPayment;
        break;
    }

    return (
      <div
        ref={(node) => (this.node = node)}
        className="transfer__window uploader uploader--error"
      >
        <div className="transfer__contents">
          <Illustration type={'transfer-aborted'} />
          <h2>{title}</h2>
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <div className="transfer__footer">
          <button
            className="transfer__button transfer__button--alt"
            onClick={action}
          >
            {button}
          </button>
        </div>
      </div>
    );
  }
}

Aborted.propTypes = {
  resetTransferState: PropTypes.func.isRequired,
  signout: PropTypes.func.isRequired,
  storageLimit: PropTypes.number,
  transfer: PropTypes.object,
};

const mapDispatchToProps = {
  resetTransferState: Actions.Transfer.resetState,
  signout: Actions.User.signout.bind(Actions.User),
};

export default connect(
  null,
  mapDispatchToProps
)(Aborted);
